import { Route, Routes } from "react-router-dom";
import { OSCI0103006S } from "../usr/org/OSCI0103006S";
import { OSCI0103007S } from "../usr/org/OSCI0103007S";
import { OSCI0103005Q } from "../usr/org/OSCI0103005Q";
import { OSCI0103008Q } from "../usr/org/OSCI0103008Q";
import { OSCI0103010Q } from "../usr/orgusr/OSCI0103010Q";
import { OSCI0103011S } from "../usr/orgusr/OSCI0103011S";
import { OSCI0103012S } from "../usr/orgusr/OSCI0103012S";
import { OSCI0103013Q } from "../usr/orgusr/OSCI0103013Q";
import { OSCI0103019Q } from "../usr/orgusraprv/OSCI0103019Q";
import { OSCI0103020S } from "../usr/orgusraprv/OSCI0103020S";
import { OSCI0103021Q } from "../usr/orgusraprv/OSCI0103021Q";
import { OSCI0103022S } from "../usr/orgusraprv/OSCI0103022S";
import { OSCI0103014Q } from "../usr/orgusr/OSCI0103014Q";
import { OSCI0103015S } from "../usr/orgusr/OSCI0103015S";
import { OSCI0103016S } from "../usr/orgusr/OSCI0103016S";
import { OSCI0103017Q } from "../usr/orgusr/OSCI0103017Q";
import { OSCI0103009Q } from "../usr/orgdept/OSCI0103009Q";
import { OSCI0103002Q } from "../usr/info/OSCI0103002Q";
import { OSCI0103003S } from "../usr/info/OSCI0103003S";
import { OSCI0103023Q } from "../usr/info/OSCI0103023Q";
import { OSCI0103024Q } from "../usr/info/OSCI0103024Q";
import { OSCI0103001S } from "../usr/info/OSCI0103001S";
import { OSCI0103004S } from "../usr/info/OSCI0103004S";

/*
 * 응용기능별 Router
 * - 명명규칙 : 응용기능 2 레벨 메타 단어(용어) 카멜표기(첫글자 대문자) + Router
 * - 응용기능 2 레벨 별로 Router 분리 원칙(기본)
 * - 응용기능 레벨별로 소문자로 구분하여 경로 작성
 * - 최종 라우팅하는 주소는 화면 아이디에서 '-' 구분자를 빼고 소문자로 변환하여 작성
 * - element 에 해당 화면 컴포넌트 기입
 * - 화면에서 파라메터로 받아서 사용할 키값은 path 문자열에 ':변수명' 으로 기입하여 해당 컴포넌트 인지하여 사용
 * TODO URL의 'key' 를 실제 ID로 변경 하세요.
 * TODO 위의 한글 주석은 마지막에 전부 삭제하세요.
 */
export const UsrRouter = () => {
    return (
        <Routes>
            {/** ==================== Organization Management Router START ==================== */}
            {/* Organization Management List !== 기관 관리 목록 ==! */}
            <Route path={"/org/osci0103005q"} element={<OSCI0103005Q />} />
            {/* Organization Management Registration !== 기관 관리 등록 ==! */}
            <Route path={"/org/osci0103006s"} element={<OSCI0103006S />} />
            {/* Organization Management Change !== 기관 관리 수정 ==! */}
            <Route path={"/org/osci0103007s/:orgCd"} element={<OSCI0103007S />} />
            {/* Organization Management Detail !== 기관 관리 상세 ==! */}
            <Route path={"/org/osci0103008q/:orgCd"} element={<OSCI0103008Q />} />
            {/** ==================== Organization Management Router END ==================== */}

            {/** ==================== Organization User Management Router START ==================== */}
            {/* Organization User Management List !== 기관 사용자 관리 목록 ==! */}
            <Route path={"/orgusr/osci0103010q"} element={<OSCI0103010Q />} />
            {/* Organization User Management Registration !== 기관 사용자 관리 등록 ==! */}
            <Route path={"/orgusr/osci0103011s"} element={<OSCI0103011S />} />
            {/* Organization User Management Change !== 기관 사용자 관리 수정 ==! */}
            <Route path={"/orgusr/osci0103012s/:usrIdntfId"} element={<OSCI0103012S />} />
            {/* Organization User Management Detail !== 기관 사용자 관리 상세 ==! */}
            <Route path={"/orgusr/osci0103013q/:usrIdntfId"} element={<OSCI0103013Q />} />
            {/** ==================== Organization User Management Router END ==================== */}

            {/* Organization User Approve Management List !== 기관 사용자 신청 관리 목록 ==! */}
            <Route path={"/orgusraprv/osci0103019q"} element={<OSCI0103019Q />} />
            <Route path={"/orgusraprv/osci0103020s/:usrIdntfId"} element={<OSCI0103020S />} />

            <Route path={"/orgusraprv/osci0103021q"} element={<OSCI0103021Q />} />
            <Route path={"/orgusraprv/osci0103022s/:usrIdntfId"} element={<OSCI0103022S />} />

            {/* Organization User Management List !== 기관 사용자 관리 목록 ==! */}
            <Route path={"/orgusr/osci0103014q"} element={<OSCI0103014Q />} />
            {/* Organization User Management Registration !== 기관 사용자 관리 등록 ==! */}
            <Route path={"/orgusr/osci0103015s"} element={<OSCI0103015S />} />
            {/* Organization User Management Change !== 기관 사용자 관리 수정 ==! */}
            <Route path={"/orgusr/osci0103016s/:usrIdntfId"} element={<OSCI0103016S />} />
            {/* Organization User Management Detail !== 기관 사용자 관리 상세 ==! */}
            <Route path={"/orgusr/osci0103017q/:usrIdntfId"} element={<OSCI0103017Q />} />

            {/* Organization User Management List !== 기관 사용자 관리 목록 ==! */}
            <Route path={"/orgusr/osci0103010q"} element={<OSCI0103010Q />} />
            {/* Organization User Management Registration !== 기관 사용자 관리 등록 ==! */}
            <Route path={"/orgusr/osci0103011s"} element={<OSCI0103011S />} />
            {/* Organization User Management Change !== 기관 사용자 관리 수정 ==! */}
            <Route path={"/orgusr/osci0103012s/:usrIdntfId"} element={<OSCI0103012S />} />
            {/* Organization User Management Detail !== 기관 사용자 관리 상세 ==! */}
            <Route path={"/orgusr/osci0103013q/:usrIdntfId"} element={<OSCI0103013Q />} />
            {/** ==================== Organization User Management Router END ==================== */}

            {/** ==================== OGA Departure Management Router START ==================== */}
            <Route path={"/orgdept/osci0103009q"} element={<OSCI0103009Q />} />
            {/** ==================== OGA Departure Management Router START ==================== */}

            {/** ==================== My Information Management Router START ==================== */}
            <Route path={"/info/osci0103001s"} element={<OSCI0103001S />} />
            <Route path={"/info/osci0103004s"} element={<OSCI0103004S />} />
            <Route path={"/info/osci0103002q"} element={<OSCI0103002Q />} />
            <Route path={"/info/osci0103003s"} element={<OSCI0103003S />} />
            {/** ==================== My Information Management Router START ==================== */}

            {/* External user change history list !== 외부사용자 변경이력 목록 ==! */}
            <Route path={"/info/osci0103023q"} element={<OSCI0103023Q />} />

            {/* Detailed list of external user change history !== 외부사용자 변경이력 상세 목록 ==! */}
            <Route path={"/info/osci0103024q/:usrIdntfNo/:lcneUsrYn"} element={<OSCI0103024Q />} />
        </Routes>
    );
};
